import React, { useState } from "react";
import ReactDOM from "react-dom";
import "./LaptopStateControl.scss";

import openBlack from "../../images/openClose/icon_open_black.svg";
import openRed from "../../images/openClose/icon_open_red.svg";
import closeBlack from "../../images/openClose/icon_close_black.svg";
import closeRed from "../../images/openClose/icon_close_red.svg";

export default function LaptopStateControl() {

    const [pressedButton, setPressedButton] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(null);

    return ReactDOM.createPortal(
        <div id='laptopStateControl' className="laptopStateControl">

            <button
                className="stateBtn"
                onPointerEnter={(e) => {
                    if (e.pointerType === 'mouse') setHoveredButton("open");
                }}
                onPointerLeave={(e) => {
                    if (e.pointerType === 'mouse') setHoveredButton(null); 
                    setPressedButton(null);
                    window.stopLaptopScreenAnimation();
                }}
                onPointerDown={() => {
                    setPressedButton("open");
                    const sequenceName = "startOpenAnimation";
                    window.scene.applySequence(window[sequenceName]);
                }}
                onPointerUp={() => {
                    setPressedButton(null);
                    setHoveredButton(null); 
                    window.stopLaptopScreenAnimation();
                }}
                onPointerCancel={() => {
                    setPressedButton(null);
                    setHoveredButton(null); 
                    window.stopLaptopScreenAnimation();
                }}
            >
                <img src={ hoveredButton === "open" || pressedButton === "open" ? openRed : openBlack } alt="Open Laptop"/>
            </button>

            <button
                className="stateBtn"
                onPointerEnter={(e) => {
                    if (e.pointerType === 'mouse') setHoveredButton("close");
                }}
                onPointerLeave={(e) => {
                    if (e.pointerType === 'mouse') setHoveredButton(null);
                    setPressedButton(null);
                    window.stopLaptopScreenAnimation();
                }}
                onPointerDown={() => {
                    setPressedButton("close");
                    const sequenceName = "startCloseAnimation";
                    window.scene.applySequence(window[sequenceName]);
                }}
                onPointerUp={() => {
                    setPressedButton(null);
                    setHoveredButton(null);
                    window.stopLaptopScreenAnimation();
                }}
                onPointerCancel={() => {
                    setPressedButton(null);
                    setHoveredButton(null);
                    window.stopLaptopScreenAnimation();
                }}
            >
                <img src={ hoveredButton === "close" || pressedButton === "close" ? closeRed : closeBlack } alt="Close Laptop"/>
            </button>

        </div>,
        document.getElementById("laptopOpenCloseStateControlDesk")
    );
}